import { listen } from 'quicklink';

const PrefetchLinks = {
	Init() {
		listen({
			// This example will ignore all requests to:
			//  - all "/api/*" pathnames
			//  - all ".zip" extensions
			//  - all ".pdf" extensions
			//  - URLs which contain a URL fragment
			//  - all <a> tags with "noprefetch" attribute
			//
			ignores: [
				/\/api\/?/,
				uri => uri.includes('.zip'),
				uri => uri.includes('.doc'),
				uri => uri.includes('.docx'),
				uri => uri.includes('.ppt'),
				uri => uri.includes('.pptx'),
				uri => uri.includes('.mp4'),
				uri => uri.includes('.mov'),
				uri => uri.includes('.mp3'),
				uri => uri.includes('.pdf'),
				uri => uri.includes('#'),
				(uri, elem) => elem.hasAttribute('noprefetch')
			]
		});
	}
};

export default PrefetchLinks;
